import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

@Component({
   selector: 'app-history-activity-dialog',
   templateUrl: './history-activity-dialog.component.html',
   styleUrls: ['./history-activity-dialog.component.css']
})
export class HistoryActivityDialogComponent implements OnInit {
   displayedColumns = ['Email', 'Action', 'Channel', 'Date'];
   resultsLength = 0;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild('wfpaginator', { static: true }) wpaginator: MatPaginator;
   public dataSource: any;

   constructor(private dialogRef: MatDialogRef<HistoryActivityDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   ngOnInit() {
      this.dataSource = new MatTableDataSource(this.data.item);
      this.dataSource.paginator = this.wpaginator;
   }

   convertText(taskAction) {
      return taskAction.toLowerCase().trim().replace(/\s/g, '');
   }

}

